export default __webpack_public_path__ + "static/media/tag-medium.deb4af40.svg";